import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CategoryDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-category-container',
  templateUrl: './category-container.component.html',
  styleUrls: ['./category-container.component.scss']
})
export class CategoryContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  categorys$: Observable<CategoryDto[]>;
  loading: boolean;
  isLoadingCategory$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingCategory$ = this.gatwayFacade.isLoadingGateway("Category");
    this.categorys$ = this.gatwayFacade.loadGateway("Category");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCategory(deletedValue: any) {
    this.gatwayFacade.remove("Category", deletedValue);
  }


// this method control both the create and update

  onSubmitCategory(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Categorys;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllCategory = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllCategory.push(pullData[i]);
    }
  }

// check if the addAllCategory array is not empty, then dispatch the data to the store
   if(addAllCategory.length > 0) {
    this.gatwayFacade.add('Category', addAllCategory);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('Category', allUpdates, ['id']);
  }

   }


}
